import React, { useEffect, useState } from "react";
import { useLanguage } from "../../../../Translations/LenguageContext";
import { useParams } from "react-router-dom";
import ErrorMessage from "../../../../Components/ErrorMessage";
import Spinner from "../../../../Components/Spinner";
import { TbGalaxy } from "react-icons/tb";

const AIPermissions = ({ show, CloseModal }) => {
    const { t } = useLanguage();
    const { project_id, db_id } = useParams();
    const user_id = sessionStorage.getItem("user_id");
    const [noSQLDbRule, setNoSqlDbRule] = useState("noaccess");
    const [sqlDbRule, setSqlDbRule] = useState("noaccess");
    const [playboxRule, setPlayboxRule] = useState("noaccess");
    const [autoDeployment, setAutodeployment] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingRules, setLoadingRules] = useState(true);
    const [error, setError] = useState({ message: "", display: false });
    const [checkSaved, setCheckSaved] = useState(false)

    const HandleGetAIPermissions = async () => {
        setLoadingRules(true)
        try {
            const response = await fetch("https://aiservice.erioon.com/get_ai_settings", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id,
                    project_id
                }),
            });
            if (response.ok) {
                const result = await response.json();
                const ai_permissions = result.ai_permissions || {};

                setSqlDbRule(ai_permissions.sql_rule || "noaccess");
                setPlayboxRule(ai_permissions.playbox_rule || "noaccess");
                setNoSqlDbRule(ai_permissions.no_sql_rule || "noaccess");
                setAutodeployment(ai_permissions.autodeployment_rule || false);
            } else {
                const errorData = await response.json();
                setError({ message: "Failed to connect to the server. Please try again later.", display: true });
                setSqlDbRule("noaccess");
                setPlayboxRule("noaccess");
                setNoSqlDbRule("noaccess");
                setAutodeployment(false)
            }
        } catch (err) {
            setError({ message: "Failed to connect to the server. Please try again later.", display: true });
        } finally {
            setTimeout(() => {
                setLoadingRules(false)
            }, 800);
        }
    };

    const HandleSave = async () => {
        setLoading(true);

        const data = {
            user_id,
            project_id,
            noSQLDbRule,
            sqlDbRule,
            playboxRule,
            autoDeployment,
        };

        try {
            const response = await fetch("https://aiservice.erioon.com/set_ai_settings", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            });

            setLoading(false);

            if (response.ok) {
                setError({ message: "", display: false });
                setCheckSaved(true)
            }
        } catch (err) {
            setLoading(false);
            setError({ message: "Failed to save AI settings. Please try again later.", display: true });
        } finally {
            setTimeout(() => {
                setCheckSaved(false)
            }, 2000);
        }
    };

    useEffect(() => {
        if (show) {
            HandleGetAIPermissions()
        }
    }, [show]);


    return (

        <div className="ai_settings_cont_modal_inner">
            {loadingRules ? (
                <div className="loading_fetch_preview">
                    <div className="loading_logo_erioon">
                        <p className="loading_logo_erioon_icon">
                            <i>
                                <TbGalaxy />
                            </i>
                        </p>
                    </div>
                </div>
            ) : (
                <div>
                    <p className="share_label fade-in">AI Settings</p>
                    <p className="share_label_desc fade-in">
                        Manage how ErioonAI can interact with your project resources.
                        Choose the level of access for each service below.
                    </p>

                    <p className="columns_section_title fade-in">Database & Collections</p>
                    <p className="columns_section_subtitle fade-in">
                        Control whether AI can read, create or modify NoSQL collections.
                    </p>
                    <div className="ai_allow_cont_opt fade-in">
                        <button
                            className={`ai_allow_choice ${noSQLDbRule === "noaccess" ? "selected" : ""}`}
                            onClick={() => setNoSqlDbRule("noaccess")}
                        >
                            No access
                        </button>
                        <button
                            className={`ai_allow_choice ${noSQLDbRule === "fullaccess" ? "selected" : ""}`}
                            onClick={() => setNoSqlDbRule("fullaccess")}
                        >
                            Full access
                        </button>
                    </div>
{/* 
                    <p className="columns_section_title fade-in">Automatic Deployments</p>
                    <p className="columns_section_subtitle fade-in">
                        Whenever ErioonAI generates or updates your code, the deployment is handled automatically — no manual steps required.
                    </p>

                    <div className="ai_allow_cont_opt fade-in">
                        <button
                            className={`ai_allow_choice ${!autoDeployment ? "selected" : ""}`}
                            onClick={() => setAutodeployment(false)}
                        >
                            Off
                        </button>
                        <button
                            className={`ai_allow_choice ${autoDeployment ? "selected" : ""}`}
                            onClick={() => setAutodeployment(true)}
                        >
                            On
                        </button>
                    </div> */}

                    {/* <p className="columns_section_title">SQL Database</p>
                    <p className="columns_section_subtitle">
                        Set permissions for AI to query or update your relational database.
                    </p>
                    <div className="ai_allow_cont_opt">
                        <button
                            className={`ai_allow_choice ${sqlDbRule === "noaccess" ? "selected" : ""}`}
                            onClick={() => setSqlDbRule("noaccess")}
                        >
                            No access
                        </button>
                        <button
                            className={`ai_allow_choice ${sqlDbRule === "readonly" ? "selected" : ""}`}
                            onClick={() => setSqlDbRule("readonly")}
                        >
                            Read only
                        </button>
                        <button
                            className={`ai_allow_choice ${sqlDbRule === "fullaccess" ? "selected" : ""}`}
                            onClick={() => setSqlDbRule("fullaccess")}
                        >
                            Full access
                        </button>
                    </div> */}


                    <div className="ai_warning_chat_cont fade-in">
                        <p>
                            Please note: ErioonAI is part of a complex network.
                            If you have sensitive data that should remain private,
                            avoid granting access to those resources.
                        </p>
                    </div>
                    <div className="ai_settings_cont_modal_footer">
                        <ErrorMessage err={error} />
                        <div className="footer_btn_cont">
                            <button className="save_btn" onClick={HandleSave}>
                                {loading ? (
                                    <Spinner loading={loading} />
                                ) : (
                                    checkSaved ? (
                                        <i className="fa-solid fa-check"></i>
                                    ) : (
                                        t.save
                                    )
                                )}
                            </button>
                            <button className="cancel_btn" onClick={CloseModal}>
                                {t.cancel}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>

    )
}

export default AIPermissions